import UnderMaintenance from '../components/UnderMaintenance';

export default function Projects() {
  return <UnderMaintenance pageTitle="Projects" />;
}
